"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function CtaShare24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 7.5C20 7.22386 19.7761 7 19.5 7H4.5C4.22386 7 4 7.22386 4 7.5V15.5C4 15.7761 4.22386 16 4.5 16H6V18H4C2.89543 18 2 17.1046 2 16V7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V16C22 17.1046 21.1046 18 20 18H19V16H19.5C19.7761 16 20 15.7761 20 15.5V7.5ZM11.303 9.61234C11.8888 9.27415 12.6378 9.47485 12.976 10.0606L14.813 13.2424L16.0377 15.3636L17.2624 17.4848C18.2769 19.2421 17.6748 21.4891 15.9176 22.5037C14.1603 23.5182 11.9133 22.9161 10.8987 21.1589L10.6208 20.6774L10.6204 20.6768L9.67406 19.0377L8.44938 16.9165C8.1112 16.3307 8.31189 15.5817 8.89765 15.2435C9.4834 14.9053 10.2324 15.106 10.5706 15.6918C10.2324 15.106 10.4331 14.357 11.0189 14.0188C11.6044 13.6808 12.353 13.8812 12.6914 14.4664L10.8548 11.2853C10.5166 10.6995 10.7173 9.95053 11.303 9.61234Z", fill: "black" }));
}
function CtaShare24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(CtaShare24Svg, Object.assign({}, svgProps)));
}
exports.default = CtaShare24;
//# sourceMappingURL=CtaShare24.js.map